module.exports = __webpack_public_path__ + "static/media/ag-logo.c9b3e104.png";